import { setIn } from 'formik';

/**
 * Convert the API's flat validation-error map into the nested shape Formik expects.
 *
 * Laravel returns dotted keys for nested fields:
 *   { 'invoice_details.0.services.0.service_description': 'Description is too short.' }
 *
 * Passing that straight to Formik's `setErrors` stores it as a single top-level key
 * containing dots, so `errors.invoice_details[0].services[0].service_description`
 * reads as undefined and the field never shows the message. `setIn` writes each
 * dotted key as a real path instead.
 *
 * Keys without dots are unaffected, so this is safe for flat forms too.
 */
export default function toFormikErrors(apiErrors) {
  if (!apiErrors || typeof apiErrors !== 'object') return {};

  return Object.entries(apiErrors).reduce(
    // the API sends a single string per field, but tolerate an array of messages
    (acc, [path, message]) => setIn(acc, path, Array.isArray(message) ? message[0] : message),
    {}
  );
}
